export const common = {
  nav: {
    home: '首页',
    about: '关于设施',
    rooms: '客房',
    gallery: '图库',
    reservation: '预订',
    access: '交通',
    contact: '联系我们',
    forOwners: '房东支持',
    freeConsultation: '免费咨询',
  },
  hero: {
    title: '传统与现代交融',
    subtitle: '独特的住宿体验',
    description: '位于东京大田区马込的传统日式古民家整栋出租。感受日本传统之美与现代舒适的完美融合，留下难忘的美好时光。',
    bookNow: '立即预订',
    viewGallery: '查看图库',
  },
  about: {
    title: '关于设施',
    subtitle: '传统日式建筑之美与现代舒适的融合',
    description: '马込古民家位于东京都大田区宁静的住宅区，是一栋历史悠久的传统日式民居。经过精心修缮，在保留传统魅力的同时提供现代便利设施，为您带来真实的日式生活体验。',
    feature1Title: '整栋出租',
    feature1Desc: '与家人朋友独享私密空间，尽情放松',
    feature2Title: '完整厨房',
    feature2Desc: '设备齐全的厨房，可烹饪您喜爱的料理',
    feature3Title: '最多8人入住',
    feature3Desc: '宽敞空间，非常适合团体和家庭入住',
    feature4Title: '传统榻榻米',
    feature4Desc: '散发榻榻米香气与木质温暖的正宗和式空间',
  },
  rooms: {
    title: '客房',
    subtitle: '在传统和式空间中享受宁静时光',
    room1: '平面图',
    room2: '完整厨房',
    room3: '简易床铺',
    capacity: '最大入住人数',
    guests: '8人',
    amenities: '设施与配备',
    amenitiesList: '完整厨房、冰箱、微波炉、烹饪器具、餐具、Wi-Fi、空调、暖气、洗衣机、浴室、卫生间、毛巾、洗漱用品',
  },
  gallery: {
    title: '图库',
    subtitle: '通过照片感受马込古民家的魅力',
  },
  reservation: {
    title: '预订',
    subtitle: '预订您的特别住宿',
    name: '姓名',
    email: '电子邮件',
    phone: '电话号码',
    checkin: '入住日期',
    checkout: '退房日期',
    guests: '入住人数',
    message: '特殊要求',
    submit: '发送预订申请',
    submitting: '发送中...',
    success: '已收到您的预订申请，我们将尽快与您联系。',
    error: '发送失败，请重试。',
    bookingPlatforms: '也可通过以下平台预订',
    bookOnAirbnb: '在Airbnb查看空房并预订',
    bookOnJalan: '在Jalan查看空房并预订',
    orDirectBooking: '或直接联系我们',
    required: '必填',
    guestsPlaceholder: '― 请选择人数 ―',
    guestSingular: '位',
    guestPlural: '位',
    messagePlaceholder: '如有特殊要求或问题，请随时告知（500字以内）',
    confirmNote: '※ 确認予約後、我们将与您联系。',
  },
  contact: {
    title: '联系我们',
    subtitle: '如有任何问题或咨询，请随时联系我们',
    name: '姓名',
    email: '电子邮件',
    subject: '主题',
    message: '留言',
    submit: '发送',
    submitting: '发送中...',
    success: '已收到您的留言，我们将尽快与您联系。',
    error: '发送失败，请重试。',
    address: '地址',
    addressDetail: '〒143-0022 东京都大田区东马込1-12-12',
    access: '交通',
    accessDetail: '都营浅草线「马込站」步行8分钟',
    faqBannerTitle: '提交前，请先查看常见问题',
    faqBannerDesc: '我们已回答了许多关于价格、手续和运营管理的常见问题。',
    faqBannerBtn: '查看FAQ',
    accessInfoTitle: '交通信息',
    sendMessageTitle: '发送消息',
    inquiryType: '咨询类型',
    inquiryTypePlaceholder: '请选择咨询类型',
    inquiryOptions: {
      minpaku: '民泊登记・许可申请',
      ryokan: '旅馆业执照取得',
      management: '物件管理・运营代理',
      pricing: '价格・方案',
      marketing: 'Airbnb房源・营销',
      revenue: '收益模拟',
      other: '其他',
    },
    messagePlaceholder: '请填写咨询内容（500字以内）',
    detailLabel: '咨询详情',
    detailPlaceholder: '请填写物件位置、现状及您的需求（500字以内）',
  },
  access: {
    label: '交通',
    title: '交通与地图',
    subtitle: '位于东京都大田区东马込宁静住宅区的古民家',
    addressLabel: '地址',
    addressLine1: '东京都大田区东马込1-12-12',
    addressLine2: '〒143-0022 东京都大田区东马込1-12-12',
    trainLabel: '乘电车',
    trainLine1: '都营浅草线「马込站」步行约2分钟',
    trainLine2: '',
    busLabel: '乘公交',
    busLine1: '都营公交「马込站前」站步行约2分钟',
    busLine2: '',
    parkingLabel: '停车场',
    parkingLine1: '附近有收费停车场',
    parkingLine2: '如需驾车前来，请提前联系我们',
    openMap: '在Google地图中打开',
  },
  footer: {
    description: '东京大田区马込的传统古民家整栋出租住宿设施。为您带来日本之美与现代舒适完美融合的特别住宿体验。',
    quickLinks: '快速链接',
    followUs: '关注我们',
    rights: '版权所有。',
    napTitle: '横田税务会计事务所',
    napAddress: '东京都大田区东马込1-12-12',
    napAddressJa: '東京都大田区東馬込1-12-12',
    napPhone: '电话：请联系我们',
    napServiceArea: '服务区域：大田区及东京都全域',
    napAccess: '都营浅草线「马込站」步行圈内',
  },
  stickyButton: {
    title: '免费30分钟',
    subtitle: '咨询',
  },
  ownersBanner: {
    subtitle: '致考虑在东京开展Airbnb的房东',
    linkText: '了解我们的房东支持服务 →',
  },
  airbnbLead: {
    title: '想在东京开始Airbnb民宿吗？',
    description: '从民泊登记、旅馆业执照申请到物业管理，我们提供一站式全程支持。以大田区为据点，基于实际运营经验提供实用建议。',
    ctaButton: '申请免费咨询',
    badge1: '免费无义务咨询',
    badge2: '拥有实际运营经验',
    badge3: '从申请到管理全程支持',
  },
  trust: {
    badge: '选择我们的理由',
    title: '深受东京房东信赖',
    subtitle: '凭借实际运营经验和全面支持，助您走向成功。',
    point1Title: '真实Airbnb运营经验',
    point1Description: '我们在大田区实际运营自己的古民家。提供基于亲身经历而非理论的建议。',
    point2Title: '执照申请全程支持',
    point2Description: '从民泊登记到旅馆业执照申请，文件准备到行政对接，全部交给我们。',
    point3Title: '收益最大化策略',
    point3Description: '基于东京真实市场数据的定价策略。客户平均收益提升30%以上。',
    point4Title: '24小时宾客服务',
    point4Description: '多语言24小时宾客支持，让房东专注于收益，无需操心管理。',
    point5Title: '透明化报告',
    point5Description: '月度收益报告和清晰的费用结构。无隐藏费用，无意外惊喜。',
    ctaButton: '查看服务详情',
  },
  howItWorks: {
    title: '服务流程',
    subtitle: '从咨询到成功开业，简单透明的流程',
    step1Number: '01',
    step1Title: '免费咨询',
    step1Desc: '告诉我们您的物业详情和目标。我们将就执照申请、收益预期和后续步骤提供诚实建议。',
    step2Number: '02',
    step2Title: '物业评估与方案制定',
    step2Desc: '评估物业适合度，确认所需条件，制定个性化行动方案。',
    step3Number: '03',
    step3Title: '开业与持续支持',
    step3Desc: '从执照申请到宾客管理，全部交给我们。房东只需专注于收益。',
    ctaButton: '预约免费咨询',
    ctaNote: '30分钟 • 无义务 • 清晰路线图',
  },
  urgency: {
    title: '想在东京开始Airbnb民宿吗？',
    description: '执照申请规则复杂，一旦出错可能延误开业。在做决定之前，先获取清晰实用的建议。',
    ctaButton: '预约免费咨询',
    note: '30分钟咨询 • 无义务 • 基于实际运营经验',
  },
  trustRisk: {
    title: '无压力免费咨询',
    description: '我们基于实际运营经验提供实用建议。即使您决定不继续，也将获得清晰的路线图。',
    badge1Title: '无义务',
    badge1Desc: '零压力免费建议',
    badge2Title: '真实经验',
    badge2Desc: '我们运营自己的物业',
    badge3Title: '清晰路线图',
    badge3Desc: '可立即使用的实用指导',
    whatYouGetTitle: '免费咨询您将获得',
    item1: '对您物业潜力的诚实评估',
    item2: '执照申请要求和时间表の清晰说明',
    item3: '基于您所在位置の现实收益预测',
    item4: '可独立执行の分步路线图',
    ctaButton: '预约免费咨询',
    ctaNote: '周一至周五 9:00–18:00（JST）',
  },
  faq: {
    title: '常见问题',
    subtitle: '关于在东京开始和运营Airbnb民宿业务の常见问题',
    ctaText: '还有其他问题？欢迎随时咨询。',
    ctaButton: '预约免费咨询',
    q1: '如何在东京开始Airbnb？',
    a1: '在东京开始Airbnb需要获得相应执照。主要有两种选择：民泊（住宅宿泊事业）登记和旅馆业（简易宿所）执照。民泊每年最多可运营180天，需向地方政府登记。旅馆业执照允许全年运营，但需满足更严格的设施标准和消防安全要求。',
    q2: '民泊和旅馆业执照有什么区别？',
    a2: '民泊（住宅宿泊事业）は、房主が1年間最大で180日間のみを営業できる登録制度で、要件が比較的簡単ですが、営業日数に制限があります。旅馆業（简易宿所）は、全年無制限で営業できる执照ですが、より厳しめの設備標準、消防設備要件、定期点検が必要です。',
    q3: '外国人可以在日本开始Airbnb吗？',
    a3: 'はい、外国人でもAirbnbを日本で始められます。しかし、重要な要件があります。あなたは、日本の商業活動を許可されている適切な在留資格を持っている必要があります。また、あなたは物件の所有権または有効な賃貸契約を持ち、日本に住んでいる30分以内で問題に応答できる管理代表を指定する必要があります。',
    q4: '东京の民泊登记需要多长时间？',
    a4: '东京の民泊登记は、準備開始から承認まで通常2-4ヶ月かかります。包括：物件評価と準備（2-3週）、ファイル準備と消防チェック（2-4週）、地方自治体への申請（1-2週審査）、最終批准と登録（1-2週）。',
    q5: '开始需要多少费用？',
    a5: '費用はサービス範囲と物件状況によります。我们提供申請サポート、ファイル準備、現場評価を含むプラン。物业管理サービスは成績制で、初期コストを低く始めることも可能です。',
    q6: '如果自我管理困難、你们能処理哪些事务？',
    a6: '我们可以処理すべて——予約管理、客満満対応、清掃調整、鍵の受け渡し、問題処理、月度収益レポート。房东はほぼ操心のAirbnb運営を実現できます。',
    q7: 'アパートもAirbnbで始められますか？',
    a7: 'アパート管理規約が禁止していない限り、Airbnbで始められます。まず、管理規約に短期レンタル活動が禁止されていないことを確認してください。',
    q8: '近隣からのクレーム、どう対処しますか？',
    a8: '我们は客に明確な宿泊ルール（音量、ゴミ処理、共用スペースの使用等）を定義し、チェックイン時に丁寧に説明し、予防しておきます。もし本当にクレームが発生した場合、我们は24時間対応体系を持ち、状況を迅速に評価し、対処します。',
    q9: '期待できる収益はどれくらいですか？',
    a9: '収益は物件の位置、面積、設備、滞在率によって大きく異なります。東京の热门エリアでは、1LDKから2LDKの物件の月収益は20万から50万円に達する場合があります。我们は過去の運用データに基づいて無料の収益シミュレーションを提供します。',
    q10: 'ただ相談だけでもいいですか？契約を強制されることがありますか？',
    a10: 'もちろん、お気軽に相談できます。我们は当场に契約を強制することはありません。希望は充分に考慮し、自分のペースで決定してください。',
  },
  seo: {
    home: {
      title: '马込古民家 | 东京大田区传统古民家整栋出租及Airbnb运营代理',
      description: '入住东京大田区马込传统日式古民家，整栋出租最多8人。提供民泊登记、旅馆业执照申请及Airbnb运营代理服务，现役房东实务经验支持。',
      keywords: '马込古民家, 东京民宿, 大田区Airbnb, 古民家整栋出租, 民泊登记支持',
    },
    management: {
      title: '东京Airbnb运营代理服务 | 大田区及东京全域対応',
      description: '东京专业Airbnb运营代理。宾客対応、動的価格設定、清掃配慮、月度レポートの全範囲代理。大田区を基点として、東京全域の物件所有者に短期管理サービスを提供します。',
      keywords: 'Airbnb运营代理 东京, 短期租赁管理, 大田区物业管理, 宾客服务东京',
    },
    support: {
      title: '东京民泊・简易宿所開業支援 | 旅馆業执照申請代理',
      description: '东京民泊・简易宿所開業由現役房东全程支援。旅馆業执照申請、民泊登録、保健所及び消防対応、実際の運用経験に基づく確実な支援を提供します。',
      keywords: '民泊登记 东京, 旅馆业执照申请, 东京Airbnb支持, 大田区短期租赁',
    },
    forOwners: {
      title: '东京Airbnb運営代理及民泊执照支持 | 物業业主专属',
      description: '东京の物件所有者向けのAirbnb運営代理及民泊执照サポート。执照取得から日常運営、清掃まで、端から端まで完全なサポートを提供します。初めての相談は無料です。',
      keywords: '东京Airbnb房东, 民泊执照支持, 物业管理东京, Airbnb运营大田区',
    },
    pricing: {
      title: '东京Airbnb運営代理收费方案 | 透明な価格体系',
      description: '东京Airbnb運営代理及び民泊サポートの透明な価格体系。開業サポート、全套設定、運営代理、清掃パッケージ、隠し料金なし、明確です。',
      keywords: 'Airbnb运营代理 费用, 民泊支持 价格, 东京短期租赁方案, 管理费用东京',
    },
    minpakuRegistration: {
      title: '东京民泊登録ガイド | 旅馆業执照申請手順詳細',
      description: '东京民泊登録全面説明。旅馆業执照申請フロー、必要なファイル、時間表、一般的なミス、基于大田区実際の運用経験に基づく詳細な説明。',
      keywords: '民泊登记 东京, 旅馆业执照申请 东京, 东京Airbnb支持, 大田区短期租赁',
    },
    guide: {
      title: '东京民泊開業ガイド2026 | 从执照取得まで収益化の完全な説明',
      description: '东京でAirbnbビジネスを始める完全ガイド。民泊と旅馆業の違い、执照取得手順、時間表、一般的なミス、収益シミュレーション及び運営代理の選択方法を全面的に説明します。',
      keywords: '东京民泊指南, Airbnb东京入门, 民泊执照, 旅馆业执照, 东京短期租赁',
    },
    caseStudy: {
      title: '大田区民泊開業事例 | 东京Airbnb成功実績研究',
      description: '実例：大田区の物件所有者が初めての相談から3.5ヶ月で最初の予約を獲得。旅馆業执照を取得し、月収18万円以上、稼動率78%の东京民泊サポート実績。',
      keywords: '大田区民泊, 东京Airbnb案例, 旅馆业执照东京, Airbnb管理东京',
    },
    adsLanding: {
      title: '在东京合法にAirbnbビジネスを始める | 民泊・旅馆業执照サポート',
      description: '东京民泊・旅馆業执照取得専門サポート。大田区現役房东が端から端までAirbnb運営代理を提供。無料30分の相談受付中。開業サポート30万円以上。',
      keywords: '东京Airbnb合法, 民泊执照支持, 旅馆业申请东京, Airbnb創業大田区',
    },
    airbnbGuide: {
      title: '东京Airbnb合法ガイド | 民泊・旅馆業执照完全解说',
      description: '在东京合法开展Airbnbの完全ガイド。民泊登録、旅馆業执照要件、費用、時間表及び申請手順、基于大田区実際の運用経験に基づく詳細な説明。',
      keywords: 'Airbnb东京执照, 民泊登记东京, 旅馆业执照东京, Airbnb运营代理东京, 大田区短期租赁',
    },
  },
  schema: {
    management: {
      offerDescription: '月销售额の15%〜20%',
      service1: '价格調整・動的価格設定',
      service2: 'ゲスト対応（多言語）',
      service3: 'レビュー管理',
      service4: '清掃・床单配慮',
      service5: '月度売上レポート',
      service6: '確定申告支援制度',
    },
  },
  taxOffice: {
    badge: '税务会计事务所',
    sectionTitle: '横田税务会计事务所',
    sectionSubtitle: '东京都大田区東マ込の民泊税务サポート専門家',
    businessName: '横田税务会计事务所',
    businessNameEn: 'Yokota Tax & Accounting Office',
    addressLabel: '所在地',
    addressJa: '東京都大田区東馬込1-12-12',
    addressEn: '1-12-12 Higashi-Magome, Ota City, Tokyo, Japan',
    serviceAreaLabel: 'サービスエリア',
    serviceArea: '大田区及东京都全域',
    serviceAreaEn: 'Ota City and Greater Tokyo',
    accessLabel: '交通',
    accessJa: '都营浅草線「馬込站」步行圏内',
    accessEn: 'Toei Asakusa Line — Magome Station',
    openMapBtn: '在Googleマップで開く',
    supportTitle: '民泊・Airbnb税务サポート',
    supportItems: [
      '確定申告サポート制度（非申告代理）',
      '大田区民泊税务サポート',
      '东京都民泊Airbnb税务相談',
      '民泊税务サポート东京・初めての相談無料',
      'Airbnb税务相談东京・收益申告サポート',
    ],
    disclaimer: '※「確定申告サポート制度」は、申告書の準備とアドバイスを提供するだけで、税理士（申告代理）ではありません。',
    officeImageAlt: '横田税务会计事务所 — 大田区東马込の税务会计事务所',
    officeImageCaption: '横田税务会计事务所 — 东京都大田区東马込',
    officeImageSubCaption: '大田区民泊税务サポート・Airbnb税务相談东京',
  },
  managementContact: {
    title: '免费咨询表单',
    name: '姓名',
    nameRequired: '必填',
    phone: '电话号码',
    email: '电子邮件',
    emailRequired: '必填',
    propertyType: '物件类型',
    propertyTypePlaceholder: '请选择',
    propertyTypeOptions: {
      mansion1k: '公寓（1K〜1LDK）',
      mansion2ldk: '公寓（2LDK以上）',
      house: '独栋住宅',
      kominka: '古民家・独栋',
      taxConsult: '税务咨询',
      other: '其他',
    },
    consultContent: '咨询内容',
    consultContentRequired: '必填',
    consultContentCounter: '{{count}}/500字',
    consultContentPlaceholder: '请填写物件位置、现状及您的需求（500字以内）',
    submit: '申请免费咨询（完全免费）',
    submitting: '发送中...',
    success: '感谢您的咨询，我们将在2个工作日内与您联系。',
    error: '发送失败，请重试。',
    beforeContact: '咨询前须知',
    infoItems: [
      '首次咨询完全免费',
      '主要服务东京地区',
      '2个工作日内回复',
      '严格保护个人信息',
    ],
    recommendTitle: '以下情况欢迎咨询',
    recommendItems: [
      '有物件但无法自行运营',
      '想以副业形式开展民泊',
      '对现有收益不满意',
      '正在寻找清洁服务',
      '不了解如何使用Airbnb',
    ],
    confirmNote: '確認预约後、スタッフが与えます。',
  },
  privateDriver: {
    badge: 'Partner Service',
    title: '私人司机服务',
    titleEn: 'Private Driver Service',
    description: '我们的合作司机提供专业接送服务——从机场接送到观光游览。',
    descriptionHighlight: '提供英语服务的司机。',
    featureTitle: '服务特色',
    features: [
      { title: '英语服务司机', desc: '为国际宾客提供英语服务的专业司机。' },
      { title: '安全有保障', desc: '全额保险的专业司机，保证安全舒适的出行。' },
      { title: '24小时服务', desc: '早班航班或深夜抵达均可应对，提前预约确保接送。' },
      { title: '大件行李OK', desc: '可安排家庭用大型车辆，多个行李箱也没问题。' },
      { title: '定制路线', desc: '可应要求提供昭和复古景点和拍摄地的特别路线。' },
    ],
    menuTitle: '服务菜单',
    priceGuide: '价格参考',
    pricingTitle: '价格参考',
    pricingNote: '所有价格含税，仅供参考，详情请咨询。',
    discountBadge: '专属优惠',
    discountTitle: '住客专享',
    discountOff: '9折优惠',
    discountSuffix: '特别折扣',
    discountNote: '预约时请告知您的住宿信息以享受折扣。',
    discountBtn: '立即预约',
    ctaBadge: 'KOMINKA住客专享',
    ctaTitle: '住客专属优惠价格',
    ctaDesc: 'KOMINKA住客可享受私人司机服务的专属折扣。',
    ctaBtn: '预约司机',
    officialPartner: 'Official Partner',
    officialPartnerJa: '提携サービス',
    services: [
      { title: '机场接送', subtitle: '空港送迎', desc: '羽田/成田机场接送，提供迎接服务。', price: '¥8,000起' },
      { title: '东京城市游', subtitle: '東京観光ドライブ', desc: '与本地司机探索昭和时代街区、寺庙和隐藏景点。', price: '¥15,000起/3小时' },
      { title: '长期住宿支持', subtitle: '長期滞在サポート', desc: '每周或每月司机服务，用于购物、一日游和日常事务。', price: '¥40,000起/周' },
      { title: '拍摄地接送', subtitle: '撮影ロケ送迎', desc: '前往标志性昭和时代景点、复古商店街和拍摄地。', price: '¥12,000起/2小时' },
    ],
    pricing: [
      { title: '机场接送', subtitle: 'Airport Transfer', rows: [{ label: '羽田机场⇔马込（单程）', price: '¥8,000起' }, { label: '成田机场⇔马込（单程）', price: '¥14,000起' }, { label: '深夜/早晨附加费（22:00-6:00）', price: '+¥2,000' }, { label: '大件行李（3个以上行李箱）', price: '+¥1,000' }], note: '* 最多4名乘客同价' },
      { title: '东京城市游', subtitle: 'Tokyo City Tour', rows: [{ label: '3小时套餐', price: '¥15,000起' }, { label: '5小时套餐', price: '¥22,000起' }, { label: '全天（8小时）', price: '¥35,000起' }, { label: '昭和复古特别路线', price: '+¥3,000' }], note: '* 含导游费和停车费' },
      { title: '拍摄地接送', subtitle: 'Photo Location Drive', rows: [{ label: '2小时套餐', price: '¥12,000起' }, { label: '4小时套餐', price: '¥20,000起' }, { label: '景点导览选项', price: '+¥2,000' }, { label: '设备/大件行李处理', price: '+¥1,500' }], note: '* 可提前咨询路线' },
      { title: '长期住宿支持', subtitle: 'Long Stay Support', rows: [{ label: '每周一次（每月4次）', price: '¥40,000起' }, { label: '每周两次（每月8次）', price: '¥72,000起' }, { label: '单次使用（3小时）', price: '¥12,000起' }, { label: '购物/医院接送', price: '¥6,000起/次' }], note: '* 月付享9折优惠' },
    ],
  },
};

export default common;
